// extracted by mini-css-extract-plugin
module.exports = {"modal":"DspxModal_modal__1OsoN","modalRegistration":"DspxModal_modalRegistration__2Axoi"};